import axios from 'axios';

export function getUserAccess(dbUrl, dbHeaders, query, fieldList) {
    return new Promise(resolve => {
        let options = {};
        if (query && fieldList) {
            query = query + "&fields=" + fieldList
        }
        if (query) {
            axios.get(dbUrl + `user-access/?${query}`, dbHeaders) //&fields=id,partner_name,partner,person_name,level,person_status,username,first_date,last_date,bu_list,rig_list,granted_by,full_access
                .then(res => {
                    resolve(res.data)
                });
        }
        else resolve(null)
    })
}
export function getUserWellAccess(dbUrl, dbHeaders, query, fieldList) {
    console.log(query)
    return new Promise(resolve => {
        let options = {};
        if (query && fieldList) {
            query = query + "&fields=" + fieldList
        }
        if (query) {
            axios.get(dbUrl + `personnel/?${query}`, dbHeaders) //&fields=id,partner_name,partner,person_name,level,person_status,username,first_date,last_date,bu_list,rig_list,granted_by,full_access
                .then(res => {
                    console.log(res.data)
                    if (res.data && res.data[0] && res.data[0].job_access) {
                        let wellQuery = 'id=' + res.data[0].job_access.map(e => e).join("|");
                        axios.get(dbUrl + `jobs/?${wellQuery}`, dbHeaders) //&fields=id,partner_name,partner,person_name,level,person_status,username,first_date,last_date,bu_list,rig_list,granted_by,full_access
                            .then(res => {
                                resolve(res.data)
                            });
                    }
                })
        }
        else resolve(null)
    })
}
export function getUserWells(dbUrl, dbHeaders, query, fieldList, wellId, orderBy) {
    return new Promise(resolve => {
        let options = {};
        if (!query && wellId) {
            query = "id=" + wellId
        }
        if (query && fieldList) {
            query = query + "&fields=" + fieldList
        }
        if (query && orderBy) {
            query = query + "&ordering=" + orderBy
        }
        if (query) {
            axios.get(dbUrl + `jobs/?${query}`, dbHeaders)
                .then(res => {
                    if (res.data && res.data.length) {
                        for (let i = 0; i < res.data.length; i++) {

                            if (i == res.data.length - 1) {
                                resolve(res.data)
                            }
                        }

                    }
                    else resolve(null)
                })
        }
        else resolve(null)
    })
}
export function getUserFeatureList(dbUrl, dbHeaders, query, fieldList, orderBy) {
    return new Promise(resolve => {
        let options = {};

        if (query && fieldList) {
            query = query + "&fields=" + fieldList
        }
        if (query && orderBy) {
            query = query + "&ordering=" + orderBy
        }
        if (query) {
            axios.get(dbUrl + `partner-features/?${query}`, dbHeaders)
                .then(res => {
                    if (res.data && res.data.length) {
                        resolve(res.data)
                    }
                    else resolve(null)
                })
        }
        else resolve(null)
    })
}

import { setUser, setUserId, setInitialPage, setUserLevel, setUserPartner, setUserPartnerType } from '../../../../store/actions/auth.js'; // import your actions
export const getUserData = async (dbUrl, dbHeaders, userName, dispatch) => {
    console.log('WE are getting User Data')
    try {
        
        const userRes = await axios.get(`${dbUrl}users/?username=${userName}`, dbHeaders);
        if (!userRes.data || !userRes.data.length || !userRes.data[0].id) return;
        const userId = userRes.data[0].id;
        const personnelRes = await axios.get(`${dbUrl}personnel/?fields=id,partner,partner_type,initial_page_target,level,first_name,last_name,phone,type,position&user=${userId}`, dbHeaders);
        if (!personnelRes.data || !personnelRes.data.length || !personnelRes.data[0].id) return;
        sessionStorage.setItem('initial_page_target', personnelRes.data[0].initial_page_target);
        console.log("WE Are SEtting User",personnelRes.data,personnelRes.data[0].initial_page_target)
        dispatch(setUserId(personnelRes.data[0].id));
        dispatch(setInitialPage(personnelRes.data[0].initial_page_target));
        dispatch(setUserLevel(personnelRes.data[0].level));
        dispatch(setUserPartner(personnelRes.data[0].partner));
        dispatch(setUserPartnerType(personnelRes.data[0].partner_type));
        
        dispatch(setUser(personnelRes.data[0]))
      } catch (error) {
        console.error(error);
      }
  };